/** Browser-level preference: hide AI Impact Assessment guidance after "Don't show again". */
export const AI_IMPACT_GUIDANCE_DISMISSED_KEY =
  "gri.aiImpactAssessment.guidance.dismissed";

const DISMISSED_VALUE = "true";

/** Legacy cookie key — cleared when persisting to localStorage. */
const LEGACY_COOKIE_KEY = AI_IMPACT_GUIDANCE_DISMISSED_KEY;

function readDismissedFromLocalStorage(): boolean {
  try {
    return localStorage.getItem(AI_IMPACT_GUIDANCE_DISMISSED_KEY) === DISMISSED_VALUE;
  } catch {
    return false;
  }
}

function readDismissedFromLegacyCookie(): boolean {
  try {
    const needle = `${encodeURIComponent(LEGACY_COOKIE_KEY)}=`;
    const parts = String(document.cookie ?? "").split(";");
    for (const part of parts) {
      const trimmed = part.trim();
      if (trimmed.startsWith(needle)) {
        return decodeURIComponent(trimmed.substring(needle.length)) === DISMISSED_VALUE;
      }
    }
    return false;
  } catch {
    return false;
  }
}

function clearLegacyCookie() {
  try {
    document.cookie = `${encodeURIComponent(LEGACY_COOKIE_KEY)}=; Max-Age=0; Path=/; SameSite=Lax`;
  } catch {
    // ignore
  }
}

export function isAiImpactGuidanceDismissed(): boolean {
  if (readDismissedFromLocalStorage()) return true;
  if (readDismissedFromLegacyCookie()) {
    dismissAiImpactGuidance();
    return true;
  }
  return false;
}

export function dismissAiImpactGuidance(): void {
  try {
    localStorage.setItem(AI_IMPACT_GUIDANCE_DISMISSED_KEY, DISMISSED_VALUE);
  } catch {
    // Storage may be blocked or full.
  }
  clearLegacyCookie();
}
